import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import { actions, selectors } from 'src/store';
import { gameKeys, paths } from 'src/constants';
import Container from 'src/components/pages/Activities/Memory/Levels/Container';

const TIMEOUT_DURATION = 500;

const MemoryStepThreeLevels = ({
  getLevelsByCollectionId,
  hasLoaded,
  currency,
  levels,
  student,
  unlockCollection,
  updateFeedback,
}) => {
  const history = useHistory();
  const gameKey = gameKeys.MEMORY_STEP_THREE;
  const { groupKey, activityId, groupId, collectionId } = useParams();

  const handleLevelAnswer = (levelId, isCorrect, currencyId) => {
    updateFeedback({ currencyId, gameKey, levelId, isCorrect });
  };

  const handleCollectionEnd = () => {
    unlockCollection({ gameKey, collectionId });
    setTimeout(() => {
      history.replace(
        paths.build(
          paths.MEMORY_STEP_THREE_COLLECTIONS,
          groupKey,
          activityId,
          groupId
        )
      );
    }, TIMEOUT_DURATION);
  };

  useEffect(() => {
    getLevelsByCollectionId(collectionId);
  }, [getLevelsByCollectionId, collectionId]);

  return (
    <Container
      cardClassName="memory-level-card-container--step-three"
      className="memory-levels-container--step-three"
      currency={currency}
      hasLoaded={hasLoaded}
      items={levels}
      handleLevelAnswer={handleLevelAnswer}
      handleCollectionEnd={handleCollectionEnd}
      student={student}
    />
  );
};

MemoryStepThreeLevels.propTypes = {
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  currency: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  levels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  student: PropTypes.shape({}).isRequired,
  unlockCollection: PropTypes.func.isRequired,
  updateFeedback: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepThreeLevels.getHasLoaded(state),
  currency: selectors.memoryStepThreeLevels.getCurrencyData(state),
  levels: selectors.memoryStepThreeLevels.getLevelsData(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepThree,
  ...actions.feedback,
  ...actions.students,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepThreeLevels);
